import { c as r } from "../../../chunk-GSYRQO2U-911f8fc9.js";
import { createMultiStyleConfigHelpers as o } from "@chakra-ui/react";
const { definePartsStyle: e, defineMultiStyleConfig: a } = o(
  r.keys
), t = e({
  container: {
    backgroundColor: "white",
    borderColor: "primary.100",
    borderRadius: "xl",
    borderWidth: "1px",
    padding: 4,
    gap: 2,
    _hover: {
      borderColor: "primary.300",
      boxShadow: "sm"
    },
    _active: {
      backgroundColor: "primary.100"
    }
  },
  body: {
    color: "primary.500"
  },
  footer: {
    marginTop: 2
  }
}), n = a({ baseStyle: t });
export {
  n as Card
};
//# sourceMappingURL=Card.es.js.map
